import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
// import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import swal from 'sweetalert2';
import { NgxSpinnerService } from "ngx-spinner";
import { MainService } from '../../../../service/main.service'
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
declare var $: any

import { session } from '../../../../../../environments/environment.session'
import { LogService } from 'src/app/portal/service/log.service';
import Swal from 'sweetalert2';
import { CodeValueService } from '../../../service/code-value.service';
import { UtilityService } from '../../../service/utility.service';
import { Utf8EncodingService } from 'src/app/md/service/utf8-encoding.service';
@Component({
  selector: 'app-utility-code-value',
  templateUrl: './utility-code-value.component.html',
  styleUrls: ['./utility-code-value.component.css']
})
export class UtilityCodeValueComponent {

  constructor(public mainService: MainService,
    private log: LogService, private codeValueService: CodeValueService,
    private spinner: NgxSpinnerService,
    private utilityService: UtilityService,
    private utf8EncodingService:Utf8EncodingService,
  ) { }
  erpUser: any;
  b_acct_id: any;


  allFields: any = [];
  obj: any = {};
  selectField: any;
  allCodeValue: any = [];
  selectedCodeValue: any = []
  codeValueObj: any = {};
  codeValueShowObj: any = {};



  module_cd: any = null;
  logObj = { component: this.module_cd + '-CODE-VALUE' }

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();

  displayedColumns: any = ['id', 'code', 'value', 'action'];
  datasource: any;

  async ngOnInit() {


    this.module_cd = this.utilityService?.configObj?.module_cd;
    console.log(this.module_cd);

    if (!this.module_cd) {
      Swal.fire('INFO', 'FACING ISSUE WHILE NAVIGATING', 'info')
      window.history.back()
      return;
    }


    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));
    this.b_acct_id = this.erpUser.b_acct_id
    await this.getAllFields();
    await this.getCodeValue();


    console.log(this.mainService.allLableShowObj,

      this.mainService.language_cd + 'Code_Value10',
      this.mainService.language_cd
    );




  }


    buttonObj: any = {
    create_btn: {
      isCreateButton: true,
      create_btn_name: 'Add Anganwadi',
      create_button_icon: '+',

    },
    export_btn: {
      isExportButton: true,
      export_btn_name: 'Export',
      export_button_icon: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="#fff">
  <g clip-path="url(#clip0_1948_1463)">
    <path d="M7.06251 0.02375C7.02461 0.0395837 6.9902 0.0627334 6.96126 0.091875L3.83626 3.21687C3.77933 3.27581 3.74783 3.35475 3.74855 3.43669C3.74926 3.51862 3.78212 3.597 3.84006 3.65494C3.898 3.71288 3.97638 3.74575 4.05832 3.74646C4.14026 3.74717 4.21919 3.71567 4.27813 3.65875L6.87188 1.065V9.065C6.87188 9.14788 6.90481 9.22737 6.96341 9.28597C7.02202 9.34458 7.1015 9.3775 7.18438 9.3775C7.26726 9.3775 7.34675 9.34458 7.40535 9.28597C7.46396 9.22737 7.49688 9.14788 7.49688 9.065V1.065L10.0906 3.65875C10.1496 3.71567 10.2285 3.74717 10.3104 3.74646C10.3924 3.74575 10.4708 3.71288 10.5287 3.65494C10.5866 3.597 10.6195 3.51862 10.6202 3.43669C10.6209 3.35475 10.5894 3.27581 10.5325 3.21687L7.40751 0.091875C7.34904 0.0332277 7.26969 0.000183364 7.18688 0C7.14592 1.60846e-05 7.10536 0.00808579 7.06751 0.02375H7.06251Z" fill="#FFFFFF"/>
    <path d="M3.43742 5.625C1.88117 5.625 0.624922 6.88125 0.624922 8.4375V10C0.624922 10.7312 0.624922 11.2688 0.653672 11.6875C0.682422 12.1075 0.738047 12.3937 0.838672 12.6375C0.980029 12.9795 1.1875 13.2903 1.44919 13.552C1.71088 13.8137 2.02165 14.0211 2.36367 14.1625C2.60617 14.2631 2.89492 14.3187 3.31367 14.3475C3.73617 14.3762 4.26992 14.3763 5.00117 14.3763H9.37617C10.1074 14.3763 10.6449 14.3762 11.0637 14.3475C11.4837 14.3187 11.7699 14.2631 12.0137 14.1625C12.3557 14.0211 12.6665 13.8137 12.9282 13.552C13.1898 13.2903 13.3973 12.9795 13.5387 12.6375C13.6393 12.395 13.6949 12.1075 13.7237 11.6875C13.753 11.265 13.753 10.7312 13.753 10V8.4375C13.753 6.88125 12.4968 5.625 10.9405 5.625C10.8577 5.625 10.7782 5.59208 10.7196 5.53347C10.661 5.47487 10.628 5.39538 10.628 5.3125C10.628 5.22962 10.661 5.15013 10.7196 5.09153C10.7782 5.03292 10.8577 5 10.9405 5C12.8405 5 14.378 6.5375 14.378 8.4375V10.0125C14.378 10.7313 14.378 11.2875 14.3474 11.7313C14.3162 12.1831 14.2537 12.5438 14.1162 12.8813C13.9434 13.2989 13.69 13.6784 13.3704 13.998C13.0508 14.3176 12.6713 14.571 12.2537 14.7437C11.9224 14.8813 11.5599 14.9444 11.1037 14.975C10.6574 15.0056 10.1037 15.0056 9.38492 15.0056H4.98492C4.26617 15.0056 3.70992 15.0056 3.26617 14.975C2.8143 14.9437 2.45367 14.8813 2.12242 14.7437C1.70477 14.571 1.3253 14.3176 1.0057 13.998C0.686113 13.6784 0.432684 13.2989 0.259922 12.8813C0.122422 12.55 0.0599219 12.1875 0.0286719 11.7313C-0.00195312 11.285 -0.00195312 10.7313 -0.00195312 10.0125V8.4375C-0.00195312 6.5375 1.53555 5 3.43555 5C3.51843 5 3.59791 5.03292 3.65652 5.09153C3.71512 5.15013 3.74805 5.22962 3.74805 5.3125C3.74805 5.39538 3.71512 5.47487 3.65652 5.53347C3.59791 5.59208 3.51843 5.625 3.43555 5.625H3.43742Z" fill="#FFFFFF"/>
  </g>
  <defs>
    <clipPath id="clip0_1948_1463">
      <rect width="15" height="15" fill="#FFFFFF"/>
    </clipPath>
  </defs>
</svg>`,
    }
  }



  update_flag: boolean = false;
  create_flag: boolean = false;
  list_flag: boolean = true;

  goToUpdate() {
    this.obj = {};
    this.selectField = null
    this.update_flag = true;
    this.create_flag = false;
    this.list_flag = false;
  }

  goToList() {
    this.obj = {};
    this.selectField = null
    this.update_flag = false;
    this.create_flag = false;
    this.list_flag = true;
  }

  gotToCreate() {
    this.obj = {};
    this.selectField = null
    this.update_flag = false;
    this.create_flag = true;
    this.list_flag = false;
  }

  export(event:any) {

  }

  async getCodeValue() {
    this.spinner.show()
    console.log(this.b_acct_id);
    let obj = { b_acct_id: this.b_acct_id, module_cd: this.module_cd }
    var resp = await this.codeValueService.getCodeValue(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.allCodeValue = resp.data;
      this.changeField();
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "ALL CODE VALUE LIST RECEIVED SUCCESSFULLY" })
      this.spinner.hide();

    } else {
      this.spinner.hide()
      swal.fire("opps", "...Error while getting all values!", 'error');

    }
  }
  open_update(element: any) {
    this.goToUpdate();
    this.obj = Object.assign({}, element);
    this.selectField = element.field_code;
    $('.nav-tabs a[href="#tab-3"]').tab('show')
  }

  refresh() {
    this.obj = {};
    this.selectField = null
  }


  async changeField() {
    this.selectedCodeValue = [];
    for (var i = 0; i < this.allCodeValue.length; i++) {
      if (this.selectField == this.allCodeValue[i].field_code) {
        this.selectedCodeValue.push(this.allCodeValue[i])
      }
    }
    this.datasource = new MatTableDataSource(this.selectedCodeValue)
    this.datasource.paginator = this.paginator.toArray()[0];
    this.datasource.sort = this.sort.toArray()[0];
  }

  async getAllFields() {
    this.spinner.show()
    var obj: any = new Object();
    obj['domain_code'] = this.module_cd;
    obj['b_acct_id'] = this.b_acct_id
    var resp = await this.codeValueService.getFields(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "ALL FIELDS LIST RECEIVED SUCCESSFULLY" })
      this.spinner.hide();
      this.allFields = resp.data;
    } else {
      this.spinner.hide()
      swal.fire("opps", "...Error while getting all fields!", 'error');

    }
  }

  async save() {
    // Validation Code Start
    for (var i = 0; i < this.allCodeValue.length; i++) {
      if (this.obj['code'] == this.allCodeValue[i]['code'] || this.obj['value'] == this.allCodeValue[i]['value']) {
        Swal.fire("Info", "Duplicate Code Value", "info");
        return
      }
    }
    if (!this.obj['code'] || !this.obj['value'] || !this.selectField) {
      Swal.fire("Info", "Fill all the Details", "info");
      return
    }
    const isEmptyValue = !this.obj['value'].trim().length;

    if (isEmptyValue) {
      Swal.fire("Info", "Fill all the Details", "info");
      return;
    }
    // Validation Code End
    this.spinner.show();
    this.obj['create_user_id'] = this.erpUser.user_id;
    this.obj['field_code'] = this.selectField;
    this.obj['b_acct_id'] = this.b_acct_id
    var resp = await this.codeValueService.insertCodeValue(this.obj);
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'UPDATE', message: "CODE VALUE CREATED SUCCESSFULLY" })
      this.spinner.hide();
      await this.getCodeValue();
      await this.getCodeValueForService();
      this.goToList();
      this.obj = {}
      swal.fire("Success", "...code value added!", 'success');
      $('.nav-tabs a[href="#tab-1"]').tab('show');

    } else {
      this.spinner.hide();
      swal.fire("opps", "...Error while adding code value!", 'error');

    }
  }

  async update() {
    // Validation Code Start
    if (!this.obj['code'] || !this.obj['value'] || !this.selectField) {
      Swal.fire("Info", "Fill all the Details", "info");
      return
    }
    const isEmptyValue = !this.obj['value'].trim().length;

    if (isEmptyValue) {
      Swal.fire("Info", "Fill all the Details", "info");
      return;
    }
    // Validation Code End
    this.spinner.show();
    this.obj['update_user_id'] = this.erpUser.user_id;
    this.obj['field_code'] = this.selectField;
    this.obj['b_acct_id'] = this.b_acct_id
    var resp = await this.codeValueService.updateCodeValues(this.obj);
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'UPDATE', message: "CODE VALUE UPDATED SUCCESSFULLY" })
      this.spinner.hide();
      await this.getCodeValue();
      await this.getCodeValueForService();
      this.goToList();
      swal.fire("Success", "Code Value Updated!", 'success');

    } else {
      this.spinner.hide();
      swal.fire("opps", "...Error while updating code value!", 'error');

    }
  }
  async getCodeValueForService() {

    var resp = await this.codeValueService.getCodeValue(this.b_acct_id);
    var codeValueTempObj: any = {}
    var codeValueShowTempObj: any = {};
    if (resp['error'] == false) {
      for (var i = 0; i < resp.data.length; i++) {
        if (codeValueTempObj[resp.data[i]['field_code']] == undefined) {
          codeValueTempObj[resp.data[i]['field_code']] = [];
          codeValueShowTempObj[resp.data[i]['field_code']] = {}
        }
        codeValueShowTempObj[resp.data[i]['field_code']][resp.data[i].code] = resp.data[i].value;
        codeValueTempObj[resp.data[i]['field_code']].push(resp.data[i])
      }
      this.codeValueObj = codeValueTempObj;
      this.codeValueShowObj = codeValueShowTempObj;
      this.mainService.codeValueTechObj = this.codeValueObj;
      this.mainService.codeValueShowObj = this.codeValueShowObj;

    } else {

    }

  }
  async delete(element: any) {

    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id
    obj['id'] = element.id;

    this.spinner.show();
    var resp = await this.codeValueService.deleteCodeValue(JSON.stringify(obj));

    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'DELETE', message: "CODE VALUE DELETED SUCCESSFULLY" })
      await this.getCodeValue();
      await this.getCodeValueForService();
      this.spinner.hide();
      swal.fire("Success", "...code value Deleted!", 'success');
    } else {
      this.spinner.hide();
      swal.fire("opps", "...code value not deleted!", 'info');
    }
  }


  applyFilter(filterValue: any) {
    this.datasource.filter = filterValue.value.trim().toLowerCase();
  }
 

}

